import { useMeContext } from '~/modules/me/useMeContext';
import { useIsBreakpointDown } from '~/modules/common/hooks';

export const useRepliconAssistantDetection = () => {
  const isMobile = useIsBreakpointDown('sm');
  const { featureFlags } = useMeContext();

  const showRepliconAssistant =
    featureFlags?.repliconAssistant !== 'off' && !isMobile;

  return showRepliconAssistant;
};
